import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MapjsService } from '../services/mapjs.service';

// Guard criado para controle de usuários que só podem ter acesso ao mapa do sistema
@Injectable({ providedIn: 'root' })
export class MapOnlyGuard implements CanActivate {
    constructor(
        private mapJsService: MapjsService,
        private router: Router
    ) { }

    canActivate(): boolean {
        if (this.mapJsService.isMapOnly) {
            this.router.navigate(['/map']);
            return false;
        }
        return true;
    }
}